import { useTrackView } from '#src/app/shared/hooks/tracking';

export function useTrackPageView(): void {
	useTrackView('off_site_redirect_view');
}
